<template>
  <div id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
  },
  created() {
    document.title = this.$t('common.title');
    this.checkVersion();
  },
  methods: {
    async checkVersion() {
      await this.$http('versions/front/front-spdo');
    },
  },
};
</script>
